/**
 * Contact Details — sourced from environment variables.
 * Never hardcode these values directly in components.
 * To update, change the values in frontend/.env
 */

export const CONTACT_CALL    = process.env.REACT_APP_CALL_NUMBER    || '+916294116245';
export const CONTACT_WHATSAPP = process.env.REACT_APP_WHATSAPP_NUMBER || '+918617389113';
export const CONTACT_EMAIL    = process.env.REACT_APP_EMAIL           || 'learnrabbitedu@gmail.com';

/** Formatted display strings */
export const CONTACT_CALL_DISPLAY     = '+91 62941 16245';
export const CONTACT_WHATSAPP_DISPLAY = '+91 86173 89113';

/** WhatsApp deep-link helper */
export const getWhatsAppUrl = (message = 'Hi! I need information about medical admissions.') => {
  const number = CONTACT_WHATSAPP.replace(/[^0-9]/g, '');
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};

/** tel: link helper */
export const getCallUrl = () => `tel:${CONTACT_CALL}`;

/** mailto: link helper */
export const getMailUrl = () => `mailto:${CONTACT_EMAIL}`;
